/* ST 2026-10-10 (Wrike 4580728412, round 11, Ali): Apple Pay was missing in the drawer, only PayPal showed.
   theme.css clips .cart-drawer__express to one button row (against Shopify's second, empty row). If Shopify
   puts a real wallet button below that row (the buttons are light-DOM children with slot="button-<Wallet>",
   so they can be measured even though the shadow root is closed), the clip is released, so no wallet is ever hidden. */
if (!customElements.get('st-wallet-row')) {
  customElements.define(
    'st-wallet-row',
    class StWalletRow extends HTMLElement {
      connectedCallback() {
        this.check = this.check.bind(this);
        this.resizeObserver = new ResizeObserver(this.check);
        this.mutationObserver = new MutationObserver(() => this.observeButtons());
        this.mutationObserver.observe(this, { childList: true, subtree: true });
        this.observeButtons();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      get buttons() {
        return this.querySelectorAll('[slot^="button-"]');
      }

      observeButtons() {
        this.resizeObserver.observe(this);
        this.buttons.forEach((button) => this.resizeObserver.observe(button));
        this.check();
      }

      check() {
        if (this.classList.contains('is-unclipped')) return;
        const rowEnd = this.getBoundingClientRect().top + this.clientHeight;
        const hidden = [...this.buttons].some((button) => {
          const rect = button.getBoundingClientRect();
          return rect.height > 0 && rect.bottom > rowEnd + 1;
        });
        if (hidden) this.classList.add('is-unclipped');
      }
    }
  );
}
